import AT from '../actions/ActionTypes';
import { fetchAccountDetailsById } from './AccountService';

import { publishDelayedEvent } from '../utils/eventUtils';
import { getPaymentProcessor } from '../console/customers/_services/BillingService';

export const fetchAccountSucceeded = (resp: any) => {
  return {
    type: AT.FETCH_ACCOUNT_SUCCEEDED,
    payload: {
      account: resp.data, // if policyHolder does not dispatch change it to (resp.data || resp);
    },
  };
};

export const fetchAccountById = (accountId: any) => {
  return (dispatch: any) => {
    return fetchAccountDetailsById(accountId).then((resp) => {
      dispatch(fetchAccountSucceeded(resp.data));
    });
  };
};

export const getPaymentProcessorValue = () => {
  return (dispatch: any) => {
    return getPaymentProcessor().then((resp: any) => {
      dispatch({
        type: AT.GET_PAYMENT_PROCESSOR,
        payload: resp.data,
      });
    });
  };
};

export const updateExcessDetails = (details: any) => {
  return {
    type: AT.UPDATE_EXCESS_DETAILS,
    payload: details,
  };
};
